"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.778 12.333A.778.778 0 0 1 3 11.556V8.444c0-.43.348-.777.778-.777h8.555c.43 0 .778.348.778.777v3.111c0 .43-.348.778-.778.778H3.778Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 4.59c0-.722.87-1.084 1.379-.573l5.385 5.41a.814.814 0 0 1 0 1.147l-5.385 5.409c-.51.511-1.379.15-1.379-.574V4.591Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThickRightArrowIcon20.js.map